import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-light-two',
  templateUrl: './header-light-two.component.html',
  styleUrls: ['./header-light-two.component.css']
})
export class HeaderLightTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
